import React, { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import ReactTable from 'react-table';

import { Well } from 'react-bootstrap';

import { ILoanComplianceCharge, ILoanPayment } from '../../../interfaces';

import { compliancePaymentColumns } from './Columns';

const DEFAULT_SORTED = [{ desc: true, id: 'payment_date' }];

interface IProps {
  // Only to name the charge each payment settled; the charges have their own table
  charges: ILoanComplianceCharge[];
  payments: ILoanPayment[];
}

@autoBindMethods
@observer
class CompliancePaymentsTable extends Component<IProps> {
  // Rebuilt only when the charges themselves change, not on every render: the parent hands down the
  // same array until they do, and mobx-react only invalidates props it finds not shallow-equal.
  // Built inline instead, react-table would get a new columns identity, and the charge lookup would
  // be redone, every time anything above this re-rendered.
  @computed
  private get columns () {
    return compliancePaymentColumns(this.props.charges);
  }

  private renderTable () {
    const { payments } = this.props;

    if (!payments.length) {
      return <div className='empty'>No compliance payments have been logged for this account.</div>;
    }

    return (
      <ReactTable
        columns={this.columns}
        data={payments}
        defaultSorted={DEFAULT_SORTED}
        keyField='id'
        minRows={0}
        pageSize={payments.length}
        resizable={false}
        showPagination={false}
        sortable
      />
    );
  }

  public render () {
    return (
      <Well className='compliance-payments-list well-table'>
        <h3>Compliance Payments</h3>
        {this.renderTable()}
      </Well>
    );
  }
}

export default CompliancePaymentsTable;
